const appraisalGaar = {
  getResults(controlIdNumber) {
    return `/homeowner/cases/${controlIdNumber}/gaar/result/current`;
  },
  markReviewed(controlIdNumber) {
    return `/homeowner/cases/${controlIdNumber}/gaar/result/current/rulefiring/review`;
  },
  markMultipleReviewed(controlIdNumber) {
    return `/homeowner/cases/${controlIdNumber}/gaar/result/current/rulefiring/review-multiple`;
  },
  submit(controlIdNumber) {
    return `/homeowner/cases/${controlIdNumber}/gaar/submit/initiate`;
  },
  isRequired(controlIdNumber) {
    return `/homeowner/cases/${controlIdNumber}/gaar/submit/is-required`;
  }
};

export default appraisalGaar;